import { combineReducers } from 'redux'

// reducers
import { Percentil } from './percentil'

export const Reducers = combineReducers({
  Percentil
})

export default Reducers



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js